import HttpService from "./htttp.service";

class AiService {
    /**
     * Get suggested competitor brand names based on a list of profile names.
     * @param {string[]} profileNames - List of "Own Profile" names.
     * @returns {Promise<string[]>} - List of suggested competitor names.
     */
    async getCompetitorSuggestions(profileNames) {
        try {
            if (!profileNames || profileNames.length === 0) return [];

            const responsePayload = await HttpService.post("/ai/suggest-competitors", { profileNames });
            // HttpService response IS the data payload
            return responsePayload.suggestions || [];
        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
            return []; // Fail gracefully with empty list
        }
    }
    /**
     * Analyze chart data with AI.
     * @param {string} context - The context or title of the chart.
     * @param {Object} data - The sanitized chart data.
     * @param {string} question - The user's question.
     * @returns {Promise<Object>} - The AI response and usage meta.
     */
    async analyzeChart(context, data, question) {
        try {
            const responsePayload = await HttpService.post("/ai/analyze-chart", {
                context,
                data,
                question
            });
            // HttpService response IS the data payload from Axios
            return {
                answer: responsePayload.answer,
                usage: responsePayload.usage
            };
        } catch (error) {
            console.error("Error analyzing chart:", error);
            throw error; // Propagate error for UI handling
        }
    }
}

export default new AiService();
